// extracted by mini-css-extract-plugin
export default {"cover":"Card_cover__v+0Oz","shader":"Card_shader__in2QI","mask":"Card_mask__mhJ-R"};